export default {
    init : (label, sortir, ascending)=>{
        let sortOption = {label:"",sortir:"",ascending:""}
        sortOption.label = label
        sortOption.sortir = sortir
        sortOption.ascending = ascending
        return sortOption;
    }
}
